import { webAPI } from '../../../axiosInstance';

export interface ImageUploadResponse {
  success: boolean;
  message: string;
  imageUrl: {
    newFilePath: string;
    publicId: string;
  };
}


const getAllArticles = async (productDetails: any) => {
  const response = await webAPI.get('/article/profile/admin', {
    params: {
      start_page: productDetails.pages.startPage,
      limit: productDetails.pages.itemsperpage,
    },
  });
  return response.data;
};

const addArticle = async (data: any) => {
  const response = await webAPI.post('/article', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

const addArticleImage = async (data: FormData): Promise<ImageUploadResponse> => {
  const response = await webAPI.post('/article/images', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

const deleteArticle = async (data: any) => {
  const response = await webAPI.delete(`/article/delete/${data}`);
  return response.data;
};

export { getAllArticles, addArticle, addArticleImage, deleteArticle };
